module.exports = __webpack_public_path__ + "img/Res_Mus_2kl.53d08a55.jpg";